import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { CONSTANTES } from '../_util/services-util';
import { AppConfig } from '../../../app/consola/app.config';
import { CONSTANTES_SESION } from '../_util/services-util';
import { MessageService } from 'primeng/api';
import { CoreService } from './core.services';
import { NgxSpinnerService } from 'ngx-spinner';
import { AlertasService } from './alerta.service';

@Injectable()
export class AuthenticationService {

    protected baseUrl: string = AppConfig.settings.apiServer.ruta;

    returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';

    constructor(
        public messageService: MessageService,
        private http: HttpClient,
        private router: Router,
        public coreService: CoreService,
        public spinner: NgxSpinnerService,
        public msj: AlertasService,
        public route: ActivatedRoute
    ) { }

    obtainAccessToken(loginData) {
        let login = {
            numero_id: loginData.username,
            password: loginData.password
        }
        let params = {}
        const headers = new HttpHeaders({
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        });
        this.spinner.show();
        this.http.post(this.baseUrl + CONSTANTES.URI_LOGIN, login, { headers: headers })
            .subscribe(
                (data: any) => {
                    sessionStorage.setItem(CONSTANTES_SESION.USERNAME, loginData.username);
                    sessionStorage.setItem(CONSTANTES_SESION.TOKEN, 'CRM:' + data.token);
                    this.coreService.post('/user-info', params).subscribe(
                        (res: any) => {
                            sessionStorage.setItem(CONSTANTES_SESION.NOMBRE, res.name);
                            this.router.navigate([this.returnUrl]);
                        },
                        (err: any) => {
                            this.msj.error('No se pudo recuperar la información del usuario');
                        }
                    )
                },
                (err: any) => {
                    this.spinner.hide();
                    if (err.status === 401) {
                        this.msj.error('Usuario o Contraseña Incorrecta');
                    } else {
                        return err;
                    }
                }
            );
    }

    logout() {
        sessionStorage.clear();
        this.router.navigate(['/login']);
    }

    saveToken(token, user: any) {
        sessionStorage.setItem(CONSTANTES_SESION.TOKEN, 'CRM:' + token.token);
        this.router.navigate(['/']);
    }

    redirigir(url) {
        this.router.navigate([url]);
    }

    checkCredentials() {
        return sessionStorage.getItem('');
    }

}
